import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

interface Props {
  $inline?: boolean;
  $lightBorder?: boolean;
  $isErrored?: boolean;
  $highlight?: boolean;
  disabled?: boolean;
  testId?: string;
  type?: string;
}

function inlineStyle({ $inline }: Props) {
  if ($inline) {
    return css`
      display: inline-block;
      min-width: auto;
      width: auto;
    `;
  }
}

function lightBorderStyle({ $lightBorder }: Props) {
  if ($lightBorder) {
    return css`
      border-color: ${Colours.greyLight8};
    `;
  }
}

function isErroredStyle({ $isErrored }: Props) {
  if ($isErrored) {
    return css`
      border-color: ${Colours.redLight5};
    `;
  }
}

function disabledStyle({ disabled = false }: Props) {
  if (disabled) {
    return css`
      border-color: ${Colours.greyLight6};
      background: ${Colours.whiteDark1};
      color: ${Colours.greyLight1};
      opacity: 0.8;
      cursor: not-allowed;

      &::-webkit-input-placeholder {
        color: ${Colours.greyLight6} !important;
      }

      &:-ms-input-placeholder {
        color: ${Colours.greyLight6} !important;
      }
    `;
  }
}

export default styled.textarea<Props>`
  pointer-events: auto;
  display: block;
  background: ${Colours.white};
  border-radius: 1.25rem;
  padding: 1rem 1.25rem;
  appearance: none;
  border: 1px solid ${Colours.greyLight2};
  width: 100%;
  font-size: 0.933333rem;
  line-height: 1.85;
  font-weight: 400;
  min-height: 18rem;
  color: inherit;
  resize: none;
  /* ::-webkit-input-placeholder {
    line-height: normal;
  } */
  ${inlineStyle}
  ${lightBorderStyle}
  ${isErroredStyle}
  ${disabledStyle}
`;
